import * as React from "react";

interface ITransilienLineIconProps {
  line: string;
  height?: string;
  width?: string;
  className?: string;
}

export default class TransilienLineIcon extends React.PureComponent<
  ITransilienLineIconProps
> {
  render() {
    let iconId = this.props.line.trim().toLowerCase();
    if (TransilienLineIcon.iconData[iconId] === undefined)
      iconId = "transilien";

    return (
      <svg
        className={this.props.className}
        viewBox="0 0 58 58"
        focusable="false"
        height={this.props.height}
        width={this.props.width}
      >
        <circle cx="29" cy="29" r="28" fill="#FFF" />
        <path
          fill={TransilienLineIcon.iconData[iconId].fill}
          d={TransilienLineIcon.iconData[iconId].data}
        />
      </svg>
    );
  }

  static iconData: { [id: string]: { fill: string; data: string } } = {
    transilien: {
      fill: "#6f6f6f",
      data:
        "M48.1 58H9.9C4.4 58 0 53.6 0 48.1V9.9C0 4.4 4.4 0 9.9 0h38.2C53.6 0 58 4.4 58 9.9v38.2c0 5.5-4.4 9.9-9.9 9.9zm5.8-48.1c0-3.2-2.6-5.8-5.8-5.8H9.9c-3.2 0-5.8 2.6-5.8 5.8v38.2c0 3.2 2.6 5.8 5.8 5.8h38.2c3.2 0 5.8-2.6 5.8-5.8V9.9zM43.2 48.4c0 .1-.7.1-1.6.1l-1.6-.1-2.2-3.2-2.2-3.2-6.3-.1h-6.7c-.2.1-1.2 1.3-2.5 3.3L18 48.4h-1.7c-1.3 0-1.6-.1-1.5-.2.1-.1 1.4-2.2 3-4.5 1.6-2.4 2.9-4.4 2.9-4.6 0-.2-.3-.4-.8-.5-1.1-.4-2.2-1.4-2.8-2.6l-.5-1.1V24.1c0-10.5 0-10.7.4-11.6.6-1.2 1.3-2 2.4-2.5l1-.5h8.4c5.9 0 8.7.1 9.2.2.9.3 2.3 1.5 2.8 2.5.4.8.4.8.4 11.8 0 11.1 0 11.1-.4 11.8-.5 1-1.9 2.2-2.9 2.5-.5.2-.8.4-.8.6 0 .2 1.4 2.3 3 4.8 1.8 2.6 3.1 4.6 3.1 4.7zM22.9 31.6c.3-.1.8-.5 1.1-.9.5-.5.5-.7.4-1.6-.1-.9-.2-1.1-.8-1.6-1.3-1.2-2.9-1-3.9.5-1.3 2 1.1 4.7 3.2 3.6zM37 14.1c-.8-.4-.8-.4-8.3-.4-7.2.1-7.5.1-8 .4-1.2.9-1.3 1.2-1.4 4-.1 2.4 0 2.6.4 3.4.8 1.5.7 1.5 9.2 1.5 6.7 0 7.5-.1 8.1-.3.4-.2.8-.6 1.1-1 .4-.6.4-.8.4-3.3 0-3-.1-3.6-1.5-4.3zm1.3 14.1c-.8-1.6-2.6-2-3.9-.9-1.4 1.2-1.1 3.6.6 4.3.8.4 1.3.3 2.1 0 1.4-.6 1.9-2.1 1.2-3.4z",
    },
    h: {
      fill: "#A15256",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zM34 31.2h-9.9v11.2H18V15.7h6.1v10.2H34V15.7h6v26.7h-6V31.2z",
    },
    j: {
      fill: "#C7D52A",
      data:
        "M48.1 58H9.9C4.5 58 0 53.5 0 48.1V9.9C0 4.5 4.5 0 9.9 0H48c5.5 0 10 4.5 10 9.9V48c0 5.5-4.5 10-9.9 10zm5.7-48.1c0-3.2-2.6-5.7-5.7-5.7H9.9c-3.2 0-5.7 2.6-5.7 5.7V48c0 3.2 2.6 5.7 5.7 5.7H48c3.2 0 5.7-2.6 5.7-5.7V9.9zM26.4 42.5c-.7 0-1.5-.1-2.3-.2-.8-.1-1.5-.3-2.1-.5l.7-4.9c.4.1.9.3 1.4.3.5.1 1.1.1 1.7.1 1.3 0 2.3-.3 3-1.1.7-.8 1.1-2.2 1.1-4.2V15.4h6v16.9c0 3.8-.9 6.4-2.6 8-1.6 1.5-3.9 2.3-6.9 2.2z",
    },
    k: {
      fill: "#C3A500",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zM32.9 42.3l-6.5-11.5-2.3 2.8v8.7h-6V15.7h6v11.8h.1l.9-1.5c.3-.5.6-1 .9-1.4l6.1-8.9h7.4L30.6 27l9.3 15.3h-7z",
    },
    l: {
      fill: "#797FBC",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zm-33 5.7h6.1v21.6h10.6v5.1H20.7V15.7z",
    },
    n: {
      fill: "#3CB6AC",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zM28 32c-.8-1.4-1.6-3-2.4-4.6-.8-1.6-1.5-3.2-2.2-4.8h-.1c.1 1.8.1 3.6.2 5.5 0 1.9.1 4 .1 6.1v8H18V15.7h7l5.5 9.8c.8 1.4 1.6 2.9 2.3 4.5.8 1.6 1.4 3.1 2 4.6h.2c-.2-1.8-.3-3.5-.4-5.4-.1-1.8-.1-3.8-.1-5.8v-7.8H40v26.7h-6.3L28 32z",
    },
    p: {
      fill: "#F7B018",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zM36.1 30.2c-1 1-2.3 1.7-3.8 2.1-1.5.5-3.1.7-4.9.7h-1.1c-.3 0-.7 0-.9-.1v9.5h-6V16.1c.9-.2 2.1-.3 3.4-.4 1.3-.1 2.9-.2 4.8-.2s3.5.2 4.8.5c1.3.4 2.5.9 3.3 1.6.9.7 1.6 1.6 2.1 2.6.5 1.1.8 2.2.8 3.6 0 1.3-.2 2.5-.6 3.6-.5 1.1-1.1 2-1.9 2.8zm-4.7-9c-.8-.7-2-1-3.5-1-.6 0-1.1 0-1.5.1-.4 0-.7.1-1 .2v7.9c.3.1.5.1.9.1h1.1c1.6 0 2.9-.4 3.8-1.2.9-.8 1.4-1.8 1.4-3.2 0-1.3-.4-2.3-1.2-2.9z",
    },
    r: {
      fill: "#EBBDD7",
      data:
        "M48 58H10C4.5 58 0 53.5 0 48V10C0 4.5 4.5 0 10 0h38c5.5 0 10 4.5 10 10v38c0 5.5-4.5 10-10 10zm5.7-48c0-3.1-2.6-5.7-5.7-5.7H10c-3.1 0-5.7 2.6-5.7 5.7v38c0 3.1 2.6 5.7 5.7 5.7h38c3.1 0 5.7-2.6 5.7-5.7V10zM32.6 40.3c-.3-1-.7-2.4-1.1-4-.3-1.6-.8-2.8-1.5-3.4-.7-.6-1.6-.9-2.8-.9h-1.8v10.5h-6V16.1c1-.2 2.2-.3 3.5-.4 1.4-.1 2.9-.2 4.5-.2 2 0 3.7.2 5.1.5 1.4.3 2.6.9 3.5 1.6.8.6 1.4 1.4 1.8 2.3.4.9.6 2 .6 3.2.1 1.9-.4 3.3-1.4 4.4-.9 1.1-2 1.9-3.2 2.3v.1c.9.4 1.7 1 2.2 1.9.6.9 1 1.9 1.3 3.1.4 1.6.8 3.1 1.2 4.5.4 1.4.7 2.4 1 3h-6.2c-.1-.4-.4-1.1-.7-2.1zM31.4 21c-.8-.6-1.9-.9-3.3-1-.7 0-1.3 0-1.8.1-.4 0-.8.1-1 .1v7.4h2.4c1.5 0 2.7-.4 3.5-1 .8-.7 1.3-1.6 1.3-2.8 0-1.3-.3-2.2-1.1-2.8z",
    },
    u: {
      fill: "#ED0677",
      data:
        "M48 58H9.9C4.5 58 0 53.5 0 48.1V9.9C0 4.5 4.5 0 9.9 0H48c5.5 0 10 4.5 10 9.9V48c0 5.5-4.5 10-10 10zm5.8-48.1c0-3.2-2.6-5.7-5.7-5.7H9.9c-3.2 0-5.7 2.6-5.7 5.7V48c0 3.2 2.6 5.7 5.7 5.7H48c3.2 0 5.7-2.6 5.7-5.7V9.9zm-25 32.6c-3.4 0-6-1-7.9-2.9-1.9-2-2.8-5.1-2.8-9.3V15.4h6.1v15.4c0 2.3.4 4 1.3 5.2.8 1.2 2 1.7 3.6 1.7s2.8-.6 3.6-1.7c.8-1.1 1.3-2.9 1.3-5.2V15.4h6v15c0 4.1-1 7.2-2.9 9.2-2.1 2-4.8 2.9-8.3 2.9z",
    },
  };
}
